import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconGiftDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M2 11.462h6.667V8.13H2z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M16.419 6.388c-.458.458-2.377 1.128-3.84 1.558.396-1.495 1.026-3.458 1.483-3.915a1.65 1.65 0 0 1 1.178-.488c.445 0 .865.173 1.179.488.649.65.649 1.708 0 2.357m-8.84 0a1.668 1.668 0 0 1 2.359-2.357c.456.456 1.085 2.42 1.48 3.915-1.462-.43-3.38-1.1-3.838-1.558m9.429-2.945a2.48 2.48 0 0 0-1.768-.732c-.667 0-1.296.26-1.767.732-.547.547-1.107 2.21-1.473 3.478-.367-1.268-.927-2.93-1.473-3.478a2.48 2.48 0 0 0-1.768-.732 2.48 2.48 0 0 0-1.769.732 2.503 2.503 0 0 0 0 3.535c.389.39 2.435 1.202 2.51 1.229v3.254h5V8.207c.073-.027 2.12-.84 2.509-1.229a2.5 2.5 0 0 0-.001-3.535" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M15.333 11.462H22V8.13h-6.667zM15.333 22.293h5.833v-10h-5.833zM2.833 22.293h5.833v-10H2.833zM9.5 22.293h5v-10h-5z" clipRule="evenodd" /></svg></>;
}
IconGiftDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconGiftDefault;